(function() {
  if (!customElements.get("image-and-text-toggle")) {
    class ImageAndTextToggle extends HTMLElement {
      constructor() {
        super();
        this.toggles = this.querySelectorAll("[data-toggle-index]");
        this.contents = this.querySelectorAll("[data-toggle-content]");
        this.activeContent = this.querySelector("[data-toggle-content]:not(.opacity-0)");
        this.activeIndex = 0;
        this.images = this.querySelectorAll("[data-toggle-image]");
        this.fallbackImage = this.querySelector("[data-fallback-image]");
      }
      connectedCallback() {
        this.toggles.forEach(toggle => {
          toggle.addEventListener("click", () => {
            const index = parseInt(toggle.dataset.toggleIndex);
            if (index === this.activeIndex) return;
            this.switchToggle(index);
          });
        });
      }
      switchToggle(index) {
        const oldToggle = this.querySelector(`[data-toggle-index="${this.activeIndex}"]`);
        const newToggle = this.querySelector(`[data-toggle-index="${index}"]`);
        const oldContent = this.querySelector(`[data-toggle-content="${this.activeIndex}"]`);
        const newContent = this.querySelector(`[data-toggle-content="${index}"]`);
        const oldImage = this.querySelector(`[data-toggle-image="${this.activeIndex}"]`);
        const newImage = this.querySelector(`[data-toggle-image="${index}"]`);
        if (oldToggle) oldToggle.classList.remove("is-active");
        if (newToggle) newToggle.classList.add("is-active");
        if (oldContent) oldContent.classList.remove("is-active");
        if (newContent) newContent.classList.add("is-active");
        if (oldImage) oldImage.classList.remove("is-active");
        if (newImage) newImage.classList.add("is-active");
        if (newImage && newImage.children.length > 0) this.fallbackImage?.classList.add("is-hidden"); else this.fallbackImage?.classList.remove("is-hidden");
        this.activeIndex = index;
      }
    }
    customElements.define("image-and-text-toggle", ImageAndTextToggle);
  }
})();